module.exports = __webpack_public_path__ + "static/img/new-05.07fdd60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-05.png
// module id = ktBm
// module chunks = 0